import { Dictionary } from '@/src/lib/dictionary/types';
import { IconName } from '@/src/app/components/Icon/types';
import { transformURLForFrontendPaths } from '@/src/lib/utils/url.ts';

export interface ProfileNavigationItem {
  title: string;
  url: string;
  icon: IconName | null;
  showInSidebar: boolean;
  prefetch: boolean;
  testId?: string;
}

export function useCustomerNavigation(
  lang: string,
  country: string,
  dict: Dictionary,
  isOrderHistoryPageEnabled?: boolean,
) {
  const navigationItems: Array<ProfileNavigationItem> = [
    {
      title: dict.userProfile.navigation.profile,
      url: transformURLForFrontendPaths('/customer/profile', lang, country),
      icon: null,
      showInSidebar: true,
      prefetch: true,
    },
    {
      title: dict.userProfile.navigation.addresses,
      url: transformURLForFrontendPaths('/customer/addresses', lang, country),
      icon: null,
      showInSidebar: true,
      prefetch: true,
    },
    isOrderHistoryPageEnabled
      ? {
          title: dict.userProfile.navigation.orderHistory,
          url: transformURLForFrontendPaths('/customer/order-history', lang, country),
          icon: null,
          showInSidebar: true,
          prefetch: true,
        }
      : undefined,
    {
      title: dict.general.logoutButton,
      url: transformURLForFrontendPaths('/auth/logout', lang, country),
      icon: IconName.LOGOUT,
      showInSidebar: true,
      prefetch: false,
      testId: 'logout-link',
    },
  ].filter(Boolean) as Array<ProfileNavigationItem>;

  return { navigationItems };
}
